import { HeightIcon } from '@radix-ui/react-icons';

import { LabelWithoutRef } from '../../../../label/label-without-ref';
import { InputNumberWithSteps } from '../controls/input-number-with-steps';

import { cn } from '../../../../../utils/cn';

import type { SpacerEditorContentProps } from './types';

export function SpacerEditorContent({
  className,
  height,
  onHeightChange,
}: SpacerEditorContentProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium">Apariencia</p>
      <div>
        <div className="flex items-center gap-1">
          <HeightIcon className="size-4" />
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Tamaño
          </LabelWithoutRef>
        </div>
        <InputNumberWithSteps
          id="appearance-spacer-height"
          max={400}
          min={16}
          steps={[
            16, 32, 48, 64, 80, 96, 112, 128, 144, 160, 176, 192, 208, 224, 240, 256, 272, 288, 304,
            320, 336, 352, 368, 384, 400,
          ]}
          value={height === '' || height === undefined ? null : Number(height)}
          onChange={(value) => {
            if (value !== null) {
              onHeightChange?.(String(value));
            }
          }}
        />
      </div>
    </div>
  );
}
